import { ChevronLeft, ChevronRight } from 'ethena-icons';
import _ from 'lodash';
import BSPagination from 'react-bootstrap/Pagination';

export interface IPaginationProps {
  className?: string;
  includeNavArrows?: boolean;
  limit: number;
  offset: number;
  onClick: (offset: number) => void;
  total: number;
}

export const Pagination = ({
  className,
  total,
  offset,
  limit,
  onClick,
  includeNavArrows = false,
}: IPaginationProps) => {
  // first let's figure out how many pages there are total
  const totalPages = Math.ceil(total / limit);
  if (totalPages < 2) {
    return null;
  }
  const currentPage = Math.round(offset / limit) + 1; // 1 based indexing

  const onPageClick = (page) => {
    const zeroIndexPage = page - 1;
    onClick(zeroIndexPage * limit); // onclicks are in offsets
  };

  if (totalPages < 11) {
    const allPages = _.map(_.range(1, totalPages + 1), (page) => {
      return (
        <BSPagination.Item
          key={page}
          onClick={() => onPageClick(page)}
          active={page === currentPage}
        >
          {page}
        </BSPagination.Item>
      );
    });
    return (
      <BSPagination className={className}>
        {includeNavArrows && (
          <BSPagination.Item
            onClick={() => onPageClick(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <ChevronLeft height={18} width={18} />
          </BSPagination.Item>
        )}
        {allPages}
        {includeNavArrows && (
          <BSPagination.Item
            onClick={() => onPageClick(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <ChevronRight height={18} width={18} />
          </BSPagination.Item>
        )}
      </BSPagination>
    );
  }

  let bottomOfRange = currentPage - 2;
  let topRange = currentPage + 2;
  if (bottomOfRange < 1) {
    topRange = topRange + 1 - bottomOfRange;
    bottomOfRange = 1;
  }
  if (topRange > totalPages) {
    bottomOfRange = bottomOfRange - (topRange - totalPages);
    topRange = totalPages;
  }

  const nearbyPages = _.map(_.range(bottomOfRange, topRange + 1), (page) => {
    return (
      <BSPagination.Item
        key={page}
        onClick={() => onPageClick(page)}
        active={page === currentPage}
      >
        {page}
      </BSPagination.Item>
    );
  });

  return (
    <BSPagination className={className}>
      {includeNavArrows && (
        <BSPagination.Item
          onClick={() => onPageClick(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <ChevronLeft height={18} width={18} />
        </BSPagination.Item>
      )}
      {currentPage > 3 && (
        <>
          <BSPagination.Item onClick={() => onPageClick(1)}>
            1
          </BSPagination.Item>
          {currentPage > 4 && <BSPagination.Ellipsis disabled />}
        </>
      )}

      {nearbyPages}

      {currentPage < totalPages - 2 && (
        <>
          {currentPage < totalPages - 3 && <BSPagination.Ellipsis disabled />}
          <BSPagination.Item onClick={() => onPageClick(totalPages)}>
            {totalPages}
          </BSPagination.Item>
        </>
      )}
      {includeNavArrows && (
        <BSPagination.Item
          onClick={() => onPageClick(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <ChevronRight height={18} width={18} />
        </BSPagination.Item>
      )}
    </BSPagination>
  );
};
